module.exports = [{
      plugin: require('../plugins/gatsby-source-yogacars/gatsby-browser.js'),
      options: {"plugins":[],"apiUrl":"https://graph.quirk.autos/"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
